var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 14.5,
    cy: 14,
    r: 14,
    fill: "#6A758B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0801 10.8805C18.2657 10.8805 18.4202 11.0346 18.4202 11.2307V11.4119C18.4202 11.6032 18.2657 11.7621 18.0801 11.7621H10.174C9.98799 11.7621 9.8335 11.6032 9.8335 11.4119V11.2307C9.8335 11.0346 9.98799 10.8805 10.174 10.8805H11.5649C11.8475 10.8805 12.0934 10.6797 12.1569 10.3963L12.2298 10.071C12.343 9.62782 12.7155 9.3335 13.1419 9.3335H15.1118C15.5335 9.3335 15.9102 9.62783 16.0193 10.0476L16.0972 10.3958C16.1603 10.6797 16.4062 10.8805 16.6892 10.8805H18.0801ZM17.3732 17.5071C17.5184 16.1538 17.7726 12.9386 17.7726 12.9061C17.7819 12.8079 17.7499 12.7149 17.6863 12.64C17.6181 12.5698 17.5318 12.5283 17.4367 12.5283H10.82C10.7244 12.5283 10.6335 12.5698 10.5704 12.64C10.5063 12.7149 10.4748 12.8079 10.4794 12.9061C10.4803 12.9121 10.4894 13.0254 10.5047 13.2147C10.5724 14.0558 10.7611 16.3986 10.8831 17.5071C10.9694 18.3238 11.5052 18.8371 12.2814 18.8557C12.8803 18.8695 13.4974 18.8743 14.1283 18.8743C14.7227 18.8743 15.3262 18.8695 15.9438 18.8557C16.7468 18.8419 17.2822 18.3376 17.3732 17.5071Z",
    fill: "#6A758B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2a7c357b064234ddc2f2f966e7efca0f.svg";
export { ForwardRef as ReactComponent };